module.exports = __webpack_public_path__ + "img/gpjy_w.abf3adc.png";